import Vue from "vue";

Vue.filter("limit", (string, limit = 200, ellipsis = "...") => {
  let output = string.toString();
  return output.substring(0, limit - 3) + ellipsis;
});

Vue.filter("decode", string => {
  const parser = new DOMParser();
  const dom = parser.parseFromString(string, "text/html");
  return dom.body.textContent;
});
